<template>
    <div class="_d-flex">
        <div class="_d-flex _flex-column _flex-1 _overflow-hidden">
          <div id="link-item-header" class="_d-flex _mb-2">
            <span class="_text-2 _mr-2 content-ellipsis _flex-1">{{ getOfferName }}</span>
            <span class="_text-2 _text-gray-500" :class="{'dynamic-offer': offer.typeDynamicOffer}" v-if="getOfferPrice">(#{{getOfferKey(customKey)}} - {{ getOfferPrice }})</span>
          </div>
          <hot-tooltip :content="$t('dashboard.copyCheckoutLink')">
            <input tabindex="-1" class="_w-full _border-sm _border-gray-300 _p-2 _pr-7 _rounded checkout-link content-ellipsis" :id="customKey" type="url" readonly="true" :value="offerLink" @click="onClickCopy">
          </hot-tooltip>
        </div>
        <div class="_d-flex _mt-2">
            <hot-tooltip :content="buttonToolTipContent($t('dashboard.openCheckoutLink'))" class="_align-self-end">
              <button data-testid="show-external-page-button" class="hot-button _ml-3 _p-0" v-if="showExternalPageButton" @click="redirectHotlink" tabindex="-1">
                <a
                  class="_text-gray-700 _text-decoration-none _w-full _px-4 _py-2 _d-block"
                  :offer-code="customKey"
                  :href="offerLink"
                  target="_blank"
                  :class="buttonCustomClasses"
                  :tabindex="disableButtons ? '-1' : 0"
                >
                  <accessible-icon
                    iconName="external-link"
                    iconFamily="fal"
                    :description="$t('dashboard.openCheckoutLink')"
                    :useDescriptionOnlyForScreenReader="!showButtonsText"
                  />
                </a>
              </button>
            </hot-tooltip>

            <hot-tooltip :content="buttonToolTipContent($t('dashboard.copyCheckoutLink'))" class="_align-self-end">
              <button
                data-testid="copy-checkout-link-button"
                class="hot-button hot-button--primary _ml-3"
                @click="onClickCopy"
                :class="buttonCustomClasses"
                :tabindex="disableButtons ? '-1' : 0"
              >
                <accessible-icon
                  iconName="link"
                  iconFamily="fal"
                  :description="$t('dashboard.copyCheckoutLink')"
                  :useDescriptionOnlyForScreenReader="!showButtonsText"
                />
              </button>
            </hot-tooltip>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import AccessibleIcon from 'core/components/AccessibleIcon/AccessibleIcon.vue'
import formatPrice from 'core/utils/formatPrice.js'

export default {
  name: 'PublishedCheckoutLinkItem',
  components: {
    AccessibleIcon
  },
  props: {
    showExternalPageButton: {
      type: Boolean,
      default: true
    },
    customKey: {
      type: String,
      default: ''
    },
    showButtonsText: {
      type: Boolean,
      default: false
    },
    disableButtons: {
      type: Boolean,
      default: false
    },
    offer: {
      type: Object,
      default: () => ({
        hotlink: '',
        price: null,
        currencyCode: null,
        mainOffer: false,
        typeDynamicOffer: false,
        offerActivationCode: ''
      })
    },
    origin: {
      type: String
    },
    publicationType: {
      type: String
    }

  },
  data: () => ({
  }),
  computed: {
    ...mapState('dashboard', [
      'checkoutData'
    ]),
    ...mapState('builder', [
      'currentLanguage'
    ]),
    offerLink () {
      if (process.env.NODE_ENV !== 'production' && this.offer?.hotlink?.includes('app-checkout-vue')) {
        return this.offer.hotlink.replace('app-checkout-vue', 'app-hotmart-checkout')
      }
      return this.offer?.hotlink
    },
    buttonCustomClasses () {
      return {'_d-flex': this.showButtonsText, '_align-items-center': this.showButtonsText}
    },
    getOfferPrice () {
      if (this.offer?.typeDynamicOffer) return this.$t('dashboard.dynamicOffer')
      if (this.offer?.currencyCode && this.offer?.price) {
        return formatPrice(this.currentLanguage, this.offer?.currencyCode, this.offer?.price)
      }

      return ''
    },
    getOfferName () {
      if (this.offer?.mainOffer) { return this.$t('dashboard.mainOffer') }
      if (this.offer?.offerActivationCode) { return this.offer?.offerActivationCode }

      return this.$t('dashboard.defaultCheckout')
    }
  },
  methods: {
    ...mapActions('notification', {
      showNotification: 'SHOW_NOTIFICATION'
    }),
    ...mapActions('datahubEvents', {
      sendCopyCheckoutLink: 'SEND_COPY_CHECKOUT_LINK'
    }),
    getOfferKey (customKey) {
      if (typeof customKey !== 'string') return ''
      if (customKey.includes('.')) return customKey.split('.')[1]
      return customKey
    },
    buttonToolTipContent (message) {
      return this.showButtonsText ? '' : message
    },
    onClickCopy () {
      this.copyCurrentLink()
      this.sendCopyCheckoutLink({ publicationType: this.publicationType, actionOrigin: this.origin })
    },
    copyCurrentLink () {
      document.getElementById(this.customKey).select()
      document.execCommand('copy')
      this.showNotification([this.$t('commonText.copiedLink'), 'success'])

      this.$analytics('send', {
        hitType: 'event',
        eventCategory: 'Manage Checkout',
        eventAction: 'copy-hotlinks'
      })
    },
    redirectHotlink () {
      this.$analytics('send', {
        hitType: 'event',
        eventCategory: 'Manage Checkout',
        eventAction: 'redirect-hotlinks'
      })
    },
    numberWithCommas (number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  watch: {
    disableButtons (value) {
      if (!value) {
        document.querySelectorAll('#checkout-links-collapse button')[1].focus()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~stylesheets/base';

  .checkout-link {
    border: 1px solid;
  }

  .title-container {
    width: 72%;
  }

  .dynamic-offer {
    color: #5a38c6 !important;
  }

</style>
